<app-dialog-heading [heading]="heading"></app-dialog-heading>
<div class="dialog-content">
  <form [formGroup]="justificationFormGroup">

    <mat-form-field>
      <mat-label>Action Required</mat-label>
      <mat-select required [formControl]="actionRequiredFormControl">
        <mat-option *ngFor="let type of assessmentNarrativeTypes" [value]="type.name">
          {{type.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Action Required')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field appearance="fill">
      <mat-label>Justification</mat-label>
      <textarea matInput required type="text" [formControl]="justificationFormControl"></textarea>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Justification')" class="info-icon">help_outline</mat-icon>

  </form>

  <p>Justification Date: {{assessmentDate | date: dateFormat}} By {{getAssessmentUser()}}</p>

</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button color="primary" (click)="onSaveClick()">Save</button>
  <button class="dialog-button" mat-raised-button color="warn" (click)="onCancelClick()">Cancel</button>
</mat-dialog-actions>
